import { CircularProgress } from '@material-ui/core';
import axios from 'axios';
import React, {
  ChangeEvent,
  useCallback,
  useEffect,
  useRef,
  useState,
} from 'react';
import { Col, Row } from 'react-bootstrap';
import { AiOutlineGlobal, AiOutlineSearch } from 'react-icons/ai';
import { FaWhatsapp } from 'react-icons/fa';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import {
  InputCidade,
  InputMaskCelular,
  InputMaskCep,
  InputMaskCnpj,
  InputMaskTelefone,
  InputText,
} from '~/components/NovosInputs';
import Separator from '~/components/Separator';
import api from '~/services/api';
import { Container } from '../../styles';
import { useAdministradora } from '../../hooks/useAdministradora';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';

const MySwal = withReactContent(Swal);

export const AbaGeral: React.FC = () => {
  const [inputSite, setInputSite] = useState<string>('');
  const inputCidadeRef = useRef<HTMLDivElement | null>(null);

  const {
    formGeral: {
      setValue,
      getValues,
      register,
      control,
      formState: { errors },
      clearErrors,
    },
    onRowClick,
    setLoadingIcon,
    loadingIcon,
    setCidadeSelected,
    setCidade,
    clearCidade,
    cidade,
    cidadeSelected,
    documentoValido,
  } = useAdministradora();

  useEffect(() => {
    if (inputCidadeRef.current) {
      const inputCidade: HTMLInputElement | null =
        inputCidadeRef.current.querySelector('[name="cidades"]');

      if (inputCidade && cidadeSelected) {
        const { label } = cidadeSelected;
        const { value } = inputCidade;

        if (value !== label) inputCidade.value = label;
      }
    }
  }, [cidadeSelected]);

  const enterValuesDataPublic = useCallback(
    (cnpjApi: any) => {
      setValue('name', cnpjApi.data.razao_social);
      setValue('apelido', cnpjApi.data.nome_fantasia);
      setValue(
        'num_telefone',
        cnpjApi.data.ddd_telefone_1 !== ''
          ? cnpjApi.data.ddd_telefone_1.trim()
          : cnpjApi.data.ddd_telefone_1,
      );
      setValue(
        'num_celular',
        cnpjApi.data.ddd_telefone_1 !== ''
          ? cnpjApi.data.ddd_telefone_1.trim()
          : cnpjApi.data.ddd_telefone_1,
      );
      setValue('num_cep', cnpjApi.data.cep);
      setValue('des_logradouro', cnpjApi.data.logradouro);
      setValue('num_endereco', cnpjApi.data.numero);
      setValue('des_bairro', cnpjApi.data.bairro);
      setValue('des_complemento', cnpjApi.data.complemento);
      setCidade({
        cidade: cnpjApi.data.municipio,
        uf: cnpjApi.data.uf,
      });
      clearErrors();
    },
    [setValue, setCidade, clearErrors],
  );

  const searchEmpresa = useCallback(async () => {
    setLoadingIcon('buscaPessoa');

    let cnpj = getValues('num_cnpj');
    const isValidCnpj = documentoValido(cnpj);
    if (!isValidCnpj) {
      setLoadingIcon('');
      return;
    }
    cnpj = cnpj.replace(/[^\d]/g, '');

    const { data } = await api.get(`/administradora-cartoes/${cnpj}`);

    if (data.success && data.data && data.data.length > 0) {
      await MySwal.fire({
        title: 'Administradora já cadastrada',
        text: `Já existe uma Administradora cadastrada com documento ${cnpj}. Deseja editar o registro?`,
        showCancelButton: true,
        confirmButtonColor: '#8850BF',
        cancelButtonColor: '#DE350B',
        confirmButtonText: 'Sim',
        cancelButtonText: 'Não',
      }).then((result: any) => {
        if (result.isConfirmed) {
          const row: any = { row: data.data[0] };
          onRowClick(row);
          setLoadingIcon('');
        } else {
          setLoadingIcon('');
          return false;
        }
      });
    } else {
      const { data: dataBusca } = await api.get(
        `/pessoas/num_cpf_cnpj/${cnpj}`,
      );
      if (
        dataBusca.success &&
        dataBusca.data &&
        dataBusca.data.length > 0 &&
        !dataBusca.data[0].flg_administradora_cartao
      ) {
        toast.success(`Documento já cadastrado. Dados importados com sucesso.`);
        setLoadingIcon('');
        setValue('cod_pessoa', dataBusca.data[0].cod_pessoa);
        setValue('cod_contato', dataBusca.data[0].cod_contato);
        setValue('cod_endereco', dataBusca.data[0].cod_endereco);
        setValue('num_ie', dataBusca.data[0].num_ie);
        setValue('name', dataBusca.data[0].nome_pessoa);
        setValue('apelido', dataBusca.data[0].apelido_fantasia);
        setValue('num_telefone', dataBusca.data[0].num_telefone);
        setValue('num_celular', dataBusca.data[0].num_celular);
        setValue('des_contato', dataBusca.data[0].des_contato);
        setValue('email', dataBusca.data[0].email);
        setValue('site', dataBusca.data[0].site);
        setValue('num_cep', dataBusca.data[0].num_cep);
        setValue('des_logradouro', dataBusca.data[0].des_logradouro);
        setValue('num_endereco', dataBusca.data[0].num_endereco);
        setValue('des_bairro', dataBusca.data[0].des_bairro);
        setValue('des_complemento', dataBusca.data[0].des_complemento);
        setCidade({
          cidade: dataBusca.data[0].des_cidade,
          uf: dataBusca.data[0].des_sigla,
        });
        clearErrors();
      } else {
        try {
          const cnpjApi: any = await axios.get(
            `https://brasilapi.com.br/api/cnpj/v1/${cnpj}`,
          );

          if (cnpjApi.data) {
            enterValuesDataPublic(cnpjApi);
            setLoadingIcon('');
            return;
          }
        } catch {
          toast.warn(
            'Não foram encontrados dados públicos para o documento informado.',
          );
          setLoadingIcon('');
        }
      }
    }
  }, [
    documentoValido,
    setCidade,
    setValue,
    setLoadingIcon,
    getValues,
    onRowClick,
    enterValuesDataPublic,
    clearErrors,
  ]);

  const openSite = useCallback((site) => {
    if (!site) {
      toast.warning('Informe um site válido');
      return;
    }
    window.open(`https://${site}`);
  }, []);

  const openWhatsApp = useCallback(() => {
    let celular = getValues('num_celular');
    const contato = getValues('des_contato');

    const regex = new RegExp(
      /^\([1-9]{2}\) (?:[2-8]|9[1-9])[0-9]{3}-[0-9]{4}$/g,
    );
    const validacao = !regex.test(celular);

    celular = celular?.replace(/[^\d]/g, '');
    if (!celular || validacao) {
      toast.warning('Informe um número de celular válido');
      return;
    }

    celular = celular.replace(/[^\d]/g, '');
    if (!contato) {
      window.open(`https://api.whatsapp.com/send?phone=55${celular}`);
      return;
    }

    window.open(
      `https://api.whatsapp.com/send?phone=55${celular}&text=${encodeURI(
        `Olá, ${contato}`,
      )}`,
    );
  }, [getValues]);

  const searchCep = useCallback(async () => {
    if (loadingIcon !== 'cep') {
      setLoadingIcon('cep');
      let cep = getValues('num_cep');
      if (!cep) {
        toast.warning('CEP inválido');
        setLoadingIcon('');
        return;
      }
      cep = cep.replace(/[^\d]/g, '');
      if (cep === '') {
        toast.warning('CEP inválido');
        setLoadingIcon('');
        return;
      }
      try {
        // API VIACEP
        const data: any = await axios.get(
          `https://viacep.com.br/ws/${cep}/json/`,
        );
        if (data.data && !data.data.erro) {
          setValue(
            'des_logradouro',
            data.data.logradouro && data.data.logradouro.toUpperCase(),
          );
          setValue(
            'des_bairro',
            data.data.bairro && data.data.bairro.toUpperCase(),
          );
          setValue('cidades', {
            cidade: data.data.localidade && data.data.localidade.toUpperCase(),
            uf: data.data.uf,
          });
          setCidade({
            cidade: data.data.localidade && data.data.localidade.toUpperCase(),
            uf: data.data.uf,
          });
          clearErrors();
        } else {
          toast.warn('CEP não encontrado');
        }
        setLoadingIcon('');
        return;
      } catch (error: any) {
        setLoadingIcon('');
        toast.warn('CEP não encontrado');
      }
      setLoadingIcon('');
    }
  }, [
    getValues,
    setValue,
    setLoadingIcon,
    loadingIcon,
    setCidade,
    clearErrors,
  ]);

  return (
    <Container>
      <Row>
        <Col sm={12} md={3}>
          <InputMaskCnpj
            label="CNPJ"
            name="num_cnpj"
            hasButton
            clickedButton={searchEmpresa}
            loadingIcon={loadingIcon === 'buscaPessoa'}
            isError={!!errors.num_cnpj}
            control={control}
          />
        </Col>
        <Col sm={12} md={3}>
          <InputText
            label="IE"
            maxLength={100}
            name="num_ie"
            register={register}
            placeholder="Inscrição Estadual"
            disabled={false}
            toLowerCase={false}
            isError={!!errors.num_ie}
          />
        </Col>

        <Col sm={12} md={12}>
          <InputText
            label="Nome *"
            maxLength={100}
            placeholder="Informe o Nome"
            name="name"
            toLowerCase={false}
            register={register}
            disabled={false}
            isError={!!errors.name}
            onChange={(ev: ChangeEvent<HTMLInputElement>) => {
              const val = ev.target.value.toUpperCase();
              setValue('name', val);
            }}
          />
        </Col>
        <Col sm={12}>
          <Separator labelText="Contato Principal" />
        </Col>
        <Col sm={12} md={2}>
          <InputMaskTelefone
            label="Telefone"
            name="num_telefone"
            isError={!!errors.num_telefone}
            control={control}
          />
        </Col>
        <Col sm={12} md={2}>
          <div className="input-container">
            <InputMaskCelular
              label="Celular"
              name="num_celular"
              isError={!!errors.num_celular}
              control={control}
              hasButton
              clickedButton={openWhatsApp}
            />
          </div>
        </Col>
        <Col sm={12} md={8}>
          <InputText
            label="Contato"
            maxLength={50}
            placeholder="Informe o Contato"
            name="des_contato"
            toLowerCase={false}
            register={register}
            disabled={false}
            isError={!!errors.des_contato}
          />
        </Col>
        <Col sm={12} md={6}>
          <InputText
            label="E-mail"
            maxLength={100}
            placeholder="Informe o E-mail"
            name="email"
            toLowerCase
            register={register}
            disabled={false}
            isError={!!errors.email}
          />
        </Col>
        <Col sm={12} md={6}>
          <div className="input-container">
            <InputText
              label="Site"
              maxLength={150}
              placeholder="Informe a página WEB"
              name="site"
              toLowerCase
              register={register}
              disabled={false}
              isError={!!errors.site}
              onChange={(e: any) => {
                setInputSite(e.target.value);
              }}
            />
            <CustomButtonNovo
              onClick={() => openSite(inputSite)}
              type="button"
              className="min-button"
            >
              <AiOutlineGlobal color="#fff" style={{ marginTop: '-2px' }} />
            </CustomButtonNovo>
          </div>
        </Col>
        <Col sm={12}>
          <Separator labelText="Endereço" />
        </Col>
        <Col sm={12} md={2}>
          <div className="input-container">
            <InputMaskCep
              label="CEP *"
              name="num_cep"
              isError={!!errors.num_cep}
              control={control}
              hasButton
              clickedButton={searchCep}
            />
          </div>
        </Col>
        <Col sm={12} md={5}>
          <InputText
            label="Logradouro *"
            maxLength={100}
            placeholder="Informe o Logradouro"
            name="des_logradouro"
            toLowerCase={false}
            register={register}
            disabled={false}
            isError={!!errors.des_logradouro}
          />
        </Col>
        <Col sm={12} md={2}>
          <InputText
            label="Número *"
            maxLength={15}
            placeholder="Informe o Número"
            name="num_endereco"
            register={register}
            disabled={false}
            isError={!!errors.num_endereco}
          />
        </Col>
        <Col sm={12} md={3}>
          <InputText
            label="Bairro *"
            maxLength={100}
            placeholder="Informe o Bairro"
            name="des_bairro"
            toLowerCase={false}
            register={register}
            disabled={false}
            isError={!!errors.des_bairro}
          />
        </Col>
        <Col sm={12} md={8}>
          <InputText
            label="Complemento"
            maxLength={50}
            placeholder="Informe o Complemento"
            name="des_complemento"
            toLowerCase={false}
            register={register}
            disabled={false}
            isError={!!errors.des_complemento}
          />
        </Col>
        <Col sm={12} md={4} ref={inputCidadeRef}>
          <InputCidade
            label="Cidade *"
            maxLength={29}
            placeholder="Selecione a Cidade"
            name="cidades"
            register={register}
            isError={!!errors.cidades}
            control={control}
            cidadeABuscar={cidade}
            clearCampo={clearCidade}
            changeSelected={(selected) => {
              setValue('cidades', selected);
              setCidadeSelected(selected);
            }}
            setValue={setValue}
          />
        </Col>
      </Row>
    </Container>
  );
};
